import React from "react";
import { Slide } from "react-reveal";
import Mission from "../reusables/Mission";

const AboutBody = () => {
  return (
    <section className="section section-spacing-50 no-padding-bottom cloudy-bg">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="textpage-container">
              <div className="textpage-inner section-spacing-50 no-padding-top flex">
                <div className="textpage-text-side">
                  <h2 className="red">NEXUS EVENTS</h2>
                  <div className="textpage-text-body">
                    <p>
                      NEXUS EVENTS'S story begins at Nexus Lounge, located in
                      Kiwatule Najjera. Over the years of our existence, we
                      found ourselves in situations where we often hired
                      equipments for our special nights. This drove us to
                      procure our own in order to minimize costs.
                    </p>
                    <p>
                      Later on, we decided to turn our challenges into an
                      opportunity, thereby expanding our equipments inventory
                      and hence <strong>NEXUS EVENTS. </strong> We are
                      co-located with our{" "}
                      <strong>sister company, Nexus lounge</strong>, located at
                      Kiwatule-Najjera. We commenced work on{" "}
                      <strong>22nd January, 2019.</strong>
                    </p>
                    <p>
                      Our commitment to innovation and excellence invariably
                      results in a successfully completed events for our
                      clients. And we strictly hold our core values of
                      Integrity, Professionalism, Innovativeness and
                      Perseverance.
                    </p>
                    <h3>Our Vision</h3>
                    <p>“To be a one-stop Events Planner”</p>
                    <h3>Our Mission</h3>
                    <p>“To be the leading events planner in Africa”</p>

                    <h3>Location &amp; Contacts</h3>
                    <p>
                      We are located on Kiwatule-Mbogo Road, at Nexus Lounge,
                      Kampala, Uganda. You can always give us a call or WhastApp
                      on <a href="tel:+256787258 151">+256 (787) 258 151</a> or{" "}
                      <a href="tel:+256393810810">+256 (393) 810 810</a> send us
                      an email{" "}
                      <a href="mailto:info@nexuseventsug.com">
                        info@nexuseventsug.com
                      </a>
                      .
                    </p>
                  </div>
                  <div className="textpage-text-model boldTitle uppercase">
                    <p>
                      NEXUS EVENTS is Uganda's leading events planner and
                      production company with a vast experience in concerts
                      &amp; shows production, Dinner &amp; Staff Parties, Weddings,
                      Product Launches, Awards &amp; Auditions etc.
                    </p>
                  </div>
                </div>
                <Mission />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutBody;
